export const handleUrlPost = (url:string , loadId?: string | number) => {
    const queryParam = !!loadId ? `?loadId=${loadId}` : '';
    return `${url}${queryParam}`;
}